import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  static targets = []

  connect() {
    this.init();
  }

  init() {
    if (window.currentNavInstance) {
      this.cleanupPreviousInstance();
    }

    this.nav = new Nav(document.getElementById('nav'));

    window.currentNavInstance = this.nav;
  }

  disconnect() {
    this.cleanupPreviousInstance();
  }

  cleanupPreviousInstance() {
    if (window.currentNavInstance) {
      try {
        window.currentNavInstance._destroyScrollbar();
      } catch (e) {
        console.error('Erro ao limpar instância anterior do Nav:', e);
      }

      window.currentNavInstance = null;
    }
  }
}
